module.exports = vant;


//////////////////
// WEBPACK FOOTER
// external "vant"
// module id = 125
// module chunks = 6